import { render } from "./RevokeSignOffModal.vue?vue&type=template&id=9cf35e3e&scoped=true"
import script from "./RevokeSignOffModal.vue?vue&type=script&lang=js"
export * from "./RevokeSignOffModal.vue?vue&type=script&lang=js"

import "./RevokeSignOffModal.vue?vue&type=style&index=0&id=9cf35e3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cf35e3e"]])

export default __exports__